import React from "react";
import { NavLink } from "react-router-dom";

const BannerSection = () => {
  return (
    <>
      <section className="terms-banner topPageBanner">
        <div className="max-container">
          <div className="padd-90">
            <div className="text-center">
              <h1 className="heading39px roboto-regular mb20 text-color-131415">
                <span className="roboto-bold">Terms</span> & Conditions
              </h1>

              <p className="roboto-regular heading16px mb30 text-color-131415">
                "Our terms and conditions are like a box of chocolates - you
                never know what <br /> you're gonna get, but we promise it'll be
                sweet!"
              </p>
              <NavLink
                to={"/contact-us"}
                className="common-btn-class main-btn-primary roboto-regular"
              >
                Contact us
              </NavLink>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};
export default BannerSection;
